module.exports = "https://static.wanderu.com/static/media/rental-cars-logo.435dbc17.svg";